'use client';

import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

let activeModalLocks = 0;
let previousBodyOverflow = '';
let previousBodyPaddingRight = '';

interface ModalPortalProps {
  children: ReactNode;
  lockScroll?: boolean;
}

export default function ModalPortal({ children, lockScroll = true }: ModalPortalProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted || !lockScroll) return;

    const body = document.body;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    if (activeModalLocks === 0) {
      previousBodyOverflow = body.style.overflow;
      previousBodyPaddingRight = body.style.paddingRight;
      body.style.overflow = 'hidden';

      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    activeModalLocks += 1;

    return () => {
      activeModalLocks = Math.max(0, activeModalLocks - 1);

      if (activeModalLocks === 0) {
        body.style.overflow = previousBodyOverflow;
        body.style.paddingRight = previousBodyPaddingRight;
      }
    };
  }, [mounted, lockScroll]);

  if (!mounted) return null;

  return createPortal(children, document.body);
}